import { render, staticRenderFns } from "./DatafieldValidationAction.vue?vue&type=template&id=6bab9ca4"
import script from "./DatafieldValidationAction.vue?vue&type=script&lang=js"
export * from "./DatafieldValidationAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports